/*
 * rheincool — Sticky-ATC (HANDOFF.md §5.3)
 * Erscheint, sobald die Kaufbox aus dem Viewport gescrollt ist
 * (IntersectionObserver auf data-observe-Ziel). Zeigt immer die aktuell
 * gewählte Option + Gesamtpreis (Event 'rc:option-change' von
 * rc-purchase-options). CTA klickt den echten ATC-Button der Kaufbox.
 */
class RcStickyAtc extends HTMLElement {
  connectedCallback() {
    this.optionLabel = this.querySelector('[data-sticky-option]');
    this.priceEl = this.querySelector('[data-sticky-price]');
    this.cta = this.querySelector('[data-sticky-atc]');
    this.target = document.querySelector(this.dataset.observe);

    this.hidden = true;
    if (this.target && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        ([entry]) => {
          // Nur zeigen, wenn die Kaufbox wirklich aus dem Viewport gescrollt
          // ist UND der Nutzer nicht am Seitenanfang steht (Initial-Flackern)
          const show = !entry.isIntersecting && window.scrollY > 200;
          this.hidden = !show;
          document.body.classList.toggle('rc-has-sticky-atc', show);
        },
        { rootMargin: '-80px 0px 0px 0px' }
      );
      observer.observe(this.target);
    }

    const applyState = ({ label, price }) => {
      if (this.optionLabel) this.optionLabel.textContent = label;
      if (this.priceEl) this.priceEl.textContent = this.formatMoney(price);
    };
    document.addEventListener('rc:option-change', (event) => applyState(event.detail));
    // Initialzustand: purchase-options hat evtl. schon publiziert, bevor
    // dieses Script geladen war (deferred-Reihenfolge)
    if (window.rcOptionState) applyState(window.rcOptionState);

    if (this.cta) {
      this.cta.addEventListener('click', () => {
        const realAtc = document.querySelector('rc-purchase-options [data-add-to-cart]');
        if (realAtc) realAtc.click();
      });
    }
  }

  formatMoney(cents) {
    const euros = Math.floor(cents / 100);
    const rest = cents % 100;
    const grouped = new Intl.NumberFormat('de-DE').format(euros);
    return rest === 0 ? `${grouped},– €` : `${grouped},${String(rest).padStart(2, '0')} €`;
  }
}

customElements.define('rc-sticky-atc', RcStickyAtc);
